var _g, _g2, _g3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 60 60",
    "data-name": "pie chart",
    id: "pie_chart",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1 { fill: #000000; } .cls-1, .cls-2, .cls-3 { fill-rule: evenodd; } .cls-2 { fill: #4299E1; } .cls-3 { fill: #5b75a0; } ")), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M550,842c-0.474,6.588-4.111,13.6-7.5,18L524,842h26Z",
    id: "pie-chart",
    transform: "translate(-490 -810)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.432,863.732A30.047,30.047,0,0,1,490,839.92c0-15.7,11.48-28.536,28-29.92v32Z",
    "data-name": "pie-chart copy 2",
    id: "pie-chart_copy_2",
    transform: "translate(-490 -810)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M522,810a30.058,30.058,0,0,1,28,28H522V810Z",
    "data-name": "pie-chart copy",
    id: "pie-chart_copy",
    transform: "translate(-490 -810)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.9f61b54fc8db5e80e692901f8bcf31d5.svg";
export { ForwardRef as ReactComponent };